module.exports = __webpack_public_path__ + "img/0_r.601796a7.jpg";